import { render, staticRenderFns } from "./SideBySideSection.vue?vue&type=template&id=5485a734&"
import script from "./SideBySideSection.vue?vue&type=script&lang=ts&"
export * from "./SideBySideSection.vue?vue&type=script&lang=ts&"
import style0 from "./SideBySideSection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports